//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  head() {
    return {
      script: [
        {
          type: "text/javascript",
          src:
            "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
          async: true,
          defer: true,
        },
      ],
    };
  },
  props: {
    extraPadding: {
      type: Boolean,
      value: false,
      default: false,
    },
    alternateImages: {
      required: false,
      default: false,
    },
    showPhotos: {
      required: false,
      default: false,
    },
    extraClass: {
      required: false,
      type: String,
    },
    title: {
      type: String,
      default:
        "Thousands of people – from business owners to attorneys – use LegalNature every day to manage their business and personal affairs.",
    },
    dataTag: {
      required: false,
      default: "",
    },
    animate: {
      required: false,
      default: false,
    },
  },
  mounted() {
    if (window.Trustpilot)
      this.$nextTick(() =>
        window.Trustpilot.loadFromElement(this.$refs.trustBoxRef)
      );
  },
};
